// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner___31ZyZ","spinAround":"spinAround___1G51B","is-blue":"is-blue___1oWBp","is-white":"is-white___3X8R_","is-orange":"is-orange___Yn7Du","is-thin":"is-thin___qwz-K"};